import { AppSwitcher as AppSwitcherWSC } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppSwitcher = observer(({ setDisplayContent }: Props) => {
  const ss = useStores().startupStore;

  const apps = ss.apps.map((app) => ({
    id: app.id,
    appLabel: app.display_name,
    groupLabel: app.group,
    iconName: app.icon_name,
    url: app.base_url,
  }));

  return (
    <AppSwitcherWSC
      label={'App Switcher'}
      apps={apps}
      onAppClick={(appUrl) => {
        setDisplayContent(false);
        window.location.href = appUrl;
      }}
      activeAppId={'appAmericanFootballAdmin'}
    />
  );
});

export default AppSwitcher;
